(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-io.js', './ktor-ktor-http.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-http.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-serialization'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-serialization'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-serialization'.");
    }
    root['ktor-ktor-serialization'] = factory(typeof this['ktor-ktor-serialization'] === 'undefined' ? {} : this['ktor-ktor-serialization'], this['kotlin-kotlin-stdlib'], this['ktor-ktor-io'], this['ktor-ktor-http'], this['kotlinx-coroutines-core']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var Exception = kotlin_kotlin.$_$.bd;
  var VOID = kotlin_kotlin.$_$.g;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.i1;
  var captureStack = kotlin_kotlin.$_$.t8;
  var protoOf = kotlin_kotlin.$_$.fa;
  var classMeta = kotlin_kotlin.$_$.z8;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var parseAndSortHeader = kotlin_io_ktor_ktor_http.$_$.d1;
  var Companion_instance = kotlin_io_ktor_ktor_io.$_$.e;
  var CoroutineImpl = kotlin_kotlin.$_$.n8;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var isInterface = kotlin_kotlin.$_$.t9;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z7;
  var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ContentConvertException, 'ContentConvertException', classMeta, Exception);
  setMetadataFor(JsonConvertException, 'JsonConvertException', classMeta, ContentConvertException);
  function register$default(contentType, converter, configuration, $super) {
    var tmp;
    if (configuration === VOID) {
      tmp = Configuration$register$lambda;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.z43(contentType, converter, configuration);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.z43.call(this, contentType, converter, configuration);
    }
    return tmp_0;
  }
  setMetadataFor(Configuration, 'Configuration', interfaceMeta);
  function serialize(contentType, charset, typeInfo, value, $completion) {
    return this.c44(contentType, charset, typeInfo, value, $completion);
  }
  function serializeNullable(contentType, charset, typeInfo, value, $completion) {
    return this.b44(contentType, charset, typeInfo, ensureNotNull(value), $completion);
  }
  setMetadataFor(ContentConverter, 'ContentConverter', interfaceMeta, VOID, VOID, VOID, VOID, VOID, [4, 3]);
  setMetadataFor(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(deserialize$o$collect$slambda, 'deserialize$o$collect$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($collectCOROUTINE$1, '$collectCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, VOID, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(deserialize$slambda, 'deserialize$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($deserializeCOROUTINE$0, '$deserializeCOROUTINE$0', classMeta, CoroutineImpl);
  //endregion
  function ContentConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$(message, cause, this);
    captureStack(this, ContentConvertException);
  }
  function JsonConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    ContentConvertException.call(this, message, cause);
    captureStack(this, JsonConvertException);
  }
  function Configuration$register$lambda($this$null) {
    return Unit_instance;
  }
  function Configuration() {
  }
  function ContentConverter() {
  }
  function deserialize(_this__u8e3s4, body, typeInfo, charset, $completion) {
    var tmp = new $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  }
  function suitableCharset(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().y3h_1 : defaultCharset;
    var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
    return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
  }
  function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().y3h_1 : defaultCharset;
    var tmp0_iterator = parseAndSortHeader(_this__u8e3s4.t14(HttpHeaders_getInstance().g3t_1)).u();
    while (tmp0_iterator.v()) {
      var charset = tmp0_iterator.w().md();
      if (charset === '*')
        return defaultCharset;
      else if (Companion_instance.b3l(charset))
        return Companion_instance.a3l(charset);
    }
    return null;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.q44_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).i1u = function (value, $completion) {
    return this.q44_1(value, $completion);
  };
  function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    this.z44_1 = $$this$unsafeFlow;
    this.a45_1 = $charset;
    this.b45_1 = $typeInfo;
    this.c45_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$o$collect$slambda).i45 = function (value, $completion) {
    var tmp = this.j45(value, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(deserialize$o$collect$slambda).xb = function (p1, $completion) {
    return this.i45((!(p1 == null) ? isInterface(p1, ContentConverter) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$o$collect$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 3;
            var tmp_0 = this;
            tmp_0.e45_1 = this.z44_1;
            var tmp_1 = this;
            tmp_1.f45_1 = this.d45_1;
            var tmp_2 = this;
            tmp_2.g45_1 = this.f45_1;
            this.la_1 = 1;
            suspendResult = this.g45_1.d44(this.a45_1, this.b45_1, this.c45_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.h45_1 = suspendResult;
            this.la_1 = 2;
            suspendResult = this.e45_1.i1u(this.h45_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 3) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(deserialize$o$collect$slambda).j45 = function (value, completion) {
    var i = new deserialize$o$collect$slambda(this.z44_1, this.a45_1, this.b45_1, this.c45_1, completion);
    i.d45_1 = value;
    return i;
  };
  function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
    var l = function (value, $completion) {
      return i.i45(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s45_1 = _this__u8e3s4;
    this.t45_1 = collector;
  }
  protoOf($collectCOROUTINE$1).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this;
            tmp_0.u45_1 = this.t45_1;
            this.la_1 = 1;
            var tmp_1 = deserialize$o$collect$slambda_0(this.u45_1, this.s45_1.w45_1, this.s45_1.x45_1, this.s45_1.y45_1, null);
            suspendResult = this.s45_1.v45_1.j1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function _no_name_provided__qut3iv($this, $charset, $typeInfo, $body) {
    this.v45_1 = $this;
    this.w45_1 = $charset;
    this.x45_1 = $typeInfo;
    this.y45_1 = $body;
  }
  protoOf(_no_name_provided__qut3iv).z45 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$1(this, collector, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(_no_name_provided__qut3iv).j1u = function (collector, $completion) {
    return this.z45(collector, $completion);
  };
  function deserialize$slambda($body, resultContinuation) {
    this.i46_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$slambda).k46 = function (it, $completion) {
    var tmp = this.lb(it, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(deserialize$slambda).xb = function (p1, $completion) {
    return this.k46((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        if (tmp === 0) {
          this.ma_1 = 1;
          return !(this.j46_1 == null) ? true : this.i46_1.b38();
        } else if (tmp === 1) {
          throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(deserialize$slambda).lb = function (it, completion) {
    var i = new deserialize$slambda(this.i46_1, completion);
    i.j46_1 = it;
    return i;
  };
  function deserialize$slambda_0($body, resultContinuation) {
    var i = new deserialize$slambda($body, resultContinuation);
    var l = function (it, $completion) {
      return i.k46(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m44_1 = _this__u8e3s4;
    this.n44_1 = body;
    this.o44_1 = typeInfo;
    this.p44_1 = charset;
  }
  protoOf($deserializeCOROUTINE$0).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            this.la_1 = 1;
            var this_0 = asFlow(this.m44_1);
            var tmp_0 = new _no_name_provided__qut3iv(this_0, this.p44_1, this.o44_1, this.n44_1);
            suspendResult = firstOrNull(tmp_0, deserialize$slambda_0(this.n44_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_1;
            if (!(result == null)) {
              tmp_1 = result;
            } else {
              if (!this.n44_1.b38()) {
                tmp_1 = this.n44_1;
              } else {
                var tmp0_safe_receiver = this.o44_1.d3r_1;
                if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p6()) === true) {
                  tmp_1 = NullBody_instance;
                } else {
                  throw new ContentConvertException('No suitable converter found for ' + this.o44_1);
                }
              }
            }

            return tmp_1;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = deserialize;
  _.$_$.b = register$default;
  _.$_$.c = Configuration;
  _.$_$.d = ContentConverter;
  _.$_$.e = JsonConvertException;
  _.$_$.f = suitableCharset;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-serialization.js.map
